<template>
    <v-container fluid class="fill-height">
        <v-row>
            <v-col class="d-flex justify-center" cols="12">
                <v-progress-circular
                    :size="100"
                    color="primary"
                    indeterminate
                    v-if="loading"
                ></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
     
           
            
       
  
  </template>

<script>
// .. imports removed for brevity
const delay = ms => new Promise(res => setTimeout(res, ms));
export default {
    data:() => ({
        loading:true
    }),

  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
    }
  },
  async mounted(){
    await delay(3000)
    this.loading=false
        if (!this.$auth.isAuthenticated) {
            this.$auth.loginWithRedirect();
        }
        else {
            this.$router.push('/home')
        }
  }
};
</script>